const CssVariables = {
    fontFamilyLato: 'Lato',
    headerHeight: 64,
    drawerWidth: 175,
    white: '#FFFFFF',
    black: '#000000',
    primaryMain: '#00636E',
    primaryDark: '#034854',
    secondary: '#ed40a9',
    secondaryMain: '#E0E0E0',
    secondaryDark: '#F5F5F5',
    secondaryBorderColor: '#BBBBBB',
    brandMain: '#C00368',
    brandDark: '#7B004C',
    errorMain: '#D91C03',
    errorDark: '#A31502',
    warningMain: '#EF6C00',
    warningDark: '#A31502',
    infoMain: '#0288D1',
    infoDark: '#01579B',
    successMain: '#488C18',
    successDark: '#217311',
    secondaryLight: '#93e42c',
    cardTitleBackground: '#839fb0',
    accent: '#F48831',
    labelLight: '#888888',
    labelDark: '#333333',
    borderColor: '#BBBBBB',
    pink: '#F494DA',
    pinkLight: '#f6a9e1',
    pinkDark: '#aa6798',
    pinkHover: '#EFCFCF',
    orange: '#FFA053',
    orangeLight: '#ffb375',
    orangeDark: '#b2703a',
    darkGrey: '#c4c4c4',
    green: '#81c925',
    greenLight: '#9ad350',
    greenDark: '#5a8c19',
    cyanBlue: '#5B7E96',
    cyanBlueLight: '#7b97ab',
    cyanBlueDark: '#3f5869',
    tableRow: '#C1E9ED',
    columnHeader: '#d4dde4',
    tableFontColor: '#222222',
    searchButtonBackground: '#5B7E96',
    headerBackground: '#555555',
    headerTabsBackground: '#333333',
};
export default CssVariables;
//# sourceMappingURL=css-variables.js.map